<template>
  <div>
    <section class="main-content">

        <!-- <div class="inner-banner">
            <div class="container">

                <div class="articles-box">
                    <figure class="pic articles-pic fitimg mb-0">
                        <img class="img-fluid" src="build/images/aboutus-1.png" />
                    </figure>
                    <div class="text">
                        <h4 class="title text-primary">求婚/迎賓</h4>
                        <p class="txt">"Here comes the bride." The processional is the quintessential moment of your wedding day. Walking down the aisle, locking eyes with your groom and seeing the smiles (and maybe some tears) of your family and friends. Of course,
                            you need the perfect song to walk down the aisle to. Whether you're a fan of the classics like Pachelbel and Hans Zimmer or prefer to surprise guests with a string rendition of Chasing Cars, we have 100 wedding processional
                            songs for you to choose from. Once you find the perfect song to walk down the aisle to, be sure to watch the video and read the lyrics to envision your day. With your ideal love song picked out, browse our ceremony programs
                            so guests can relish in the details as they wait for the music to start.</p>
                    </div>
                </div>

            </div>
        </div> -->

        <div class="main-block">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">

                        <div class="bck-index bck-articles">
                            <h3 class="title sr-only"><span>About us</span></h3>
                            <div class="articles-items">
                                <div class="articles-box aboutus-box">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <figure class="pic articles-pic">
                                            <img class="img-fluid" src="/static/images/aboutus-1.png" />
                                        </figure>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="text">
                                                <h4 class="title text-primary">Music
                                                    </br/>Through Time</h4>
                                                <p class="txt">音樂是可以跳脫時間定律的神奇魔法！
<br/>人會老相片會泛黃，影片雖可以紀錄，
</br/>卻沒有閉上眼睛聽著歌，
</br/>帶人瞬間穿越時空，回到過去的想像力！</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="articles-box aboutus-box">

                                    <div class="row">
                                      <div class="col-md-6 push-md-6">
                                          <figure class="pic articles-pic">
                                          <img class="img-fluid" src="/static/images/aboutus-2.png" />
                                      </figure>
                                      </div>
                                        <div class="col-md-6 pull-md-6">
                                            <div class="text">
                                                <h4 class="title text-primary">Turning Love </br/>into Forever</h4>
                                                <p class="txt">婚禮歌曲常被挑選的原因，
</br/>只因為旋律好聽、搭配婚禮儀式方便，
</br/>對歌詞的含意和適用時機，缺少真正的了解，
</br/>一個讓婚姻歷久彌新、愛意永不退色的契機因而錯過。
</br/>
</br/>不論你是新人或婚禮顧問，
</br/>希望在這裡可以找到屬於新人特有的婚禮歌曲。
</br/>
</br/>我們相信用心選擇的婚禮歌曲，
</br/>會跨越貴賤、身分、國界，為婚姻帶來真摯的祝福。
</br/>我們歡迎新人分享婚禮歌曲影片，
</br/>讓幸福的聲音可被更多人聽見！</p>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="articles-box aboutus-box">

                                    <div class="row">
                                        <div class="col-md-6">
                                            <figure class="pic articles-pic">
                                            <img class="img-fluid" src="/static/images/aboutus-3.png" />
                                        </figure>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="text">
                                                <h4 class="title text-primary">Wedding Song
</br/><small class="sub-title">桅頂上聽見幸福的聲音</small></h4>
                                                <p class="txt">不管是入港，還是要出航
</br/>桅頂上，我聽見嚮往，我看見方向</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>


        </section>
  </div>
</template>

<script>
export default {
  name: 'about',
  data () {
    return {
      category: []
    }
  }
}
</script>


// WEBPACK FOOTER //
// About.vue?0cc448c5